import { useMemo, useState } from 'react'
import Link from 'next/link'
import styles from './CategoryCard.module.scss'
import { routes } from 'utils/routes'
import LottieAnimation from 'components/lottie-player/LottieAnimation'
import { Heading, Img } from '@boltenergy-be/design-system'
import { Animations, CategoryCardProps } from './types'

const CategoryCard = ({ category, language }: CategoryCardProps) => {
  // LOCAL STATE
  const [isHovered, setIsHovered] = useState<boolean>(false)

  // constants
  const animation = useMemo(() => {
    if (!category.hoverAnimation) return null

    switch (category.hoverAnimation) {
      case Animations.HOUSE:
        return '/animations/home-hover.json'
      case Animations.BROCCOLI:
        return '/animations/broccoli-hover.json'
      case Animations.SOLAR_PANEL:
        return '/animations/solar-panel-hover.json'
      default:
        return null
    }
  }, [category.hoverAnimation])

  return (
    <Link
      key={category.id}
      href={routes(language, category.slug).encyclopediaCategory}
      prefetch={false}
      className={styles.card}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {(category.icon || animation) && (
        <div className={styles['img-wrapper']}>
          <figure className={styles['out-of-bounds-box']}>
            {animation ? (
              <LottieAnimation animationData={animation} isPlaying={isHovered} />
            ) : (
              <Img
                publicId={category.icon?.provider_metadata?.public_id}
                alt={category.title}
                objectFit="contain"
                width={198}
                height={135}
              />
            )}
          </figure>
        </div>
      )}
      <div className={styles['colored-background']} style={{ backgroundColor: category.color }}>
        <Heading as="h2" variant="h5" serif>
          {category.title}
        </Heading>
      </div>
    </Link>
  )
}

export default CategoryCard
